import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import GppMaybeOutlinedIcon from '@mui/icons-material/GppMaybeOutlined'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import BeenhereOutlinedIcon from '@mui/icons-material/BeenhereOutlined'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import AssuredWorkloadOutlinedIcon from '@mui/icons-material/AssuredWorkloadOutlined'
import CurrencyBitcoinOutlinedIcon from '@mui/icons-material/CurrencyBitcoinOutlined'
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined'
import { MediationOutlined } from '@mui/icons-material'
import { useMemo } from 'react'

export const sidebarConfig = [
  {
    service: 'overview',
    title: 'common:home',
    icon: <HomeOutlinedIcon />,
    url: '/',
  },
  {
    service: 'caseManagement',
    title: 'common:intelligenceFraudEng',
    icon: <LightbulbOutlinedIcon />,
    routes: [
      {
        service: ['caseManagement'],
        url: '/case-management/case',
        title: 'messages:compliance.menu.cases',
      },
      {
        service: ['caseManagement'],
        url: '/case-management/alerts',
        title: 'common:alerts',
      },
      {
        service: ['workflows:id'],
        url: '/case-workflows',
        title: 'common:workflows',
      },
      {
        service: ['caseAdminPanel:id'],
        url: '/case-management/admin',
        title: 'common:adminPanel',
      },
      {
        service: [''],
        url: '/device',
        title: 'common:deviceIntelligence',
        isDemo: true,
      },
    ],
  },
  {
    service: '',
    title: 'manualChecks',
    icon: <BeenhereOutlinedIcon />,
    routes: [
      {
        service: ['kyt'],
        url: '/kyt/manual/consumer',
        title: 'KYT',
      },
      {
        service: ['aml'],
        url: '/aml/manual',
        title: 'common:amlAndList',
      },
      {
        service: ['amlCrypto'],
        url: '/aml-crypto/manual',
        title: 'common:amlCrypto',
      },
      {
        service: ['onboarding'],
        url: '/onboardings/manual',
        title: 'common:onboarding',
      },
      {
        service: ['govCheck'],
        url: '/gov-check/manual',
        title: 'common:govcheck',
      },
    ],
  },
  {
    service: 'kyb',
    title: 'messages:kyb.menu',
    icon: <LeaderboardOutlinedIcon />,
    routes: [
      {
        service: ['kyb'],
        url: '/kyb/all',
        title: 'messages:kyb.menu.history',
      },
      {
        service: ['kyb'],
        url: '/kyb/notifications',
        title: 'messages:kyb.menu.notifications',
      },
      // {
      //   service: ['kyb'],
      //   url: '/kyb/notificationsv2',
      //   title: 'messages:kyb.menu.notificationsV2',
      // },
      {
        service: ['kyb'],
        url: '/kyb/lists/CNPJ',
        title: 'messages:kyb.menu.blockedClients',
      },
      {
        service: ['kyb'],
        url: '/kyb/batches',
        title: 'messages:kyb.menu.loadInBatches',
      },
      {
        service: ['kyb'],
        url: '/kyb/settings',
        title: 'messages:kyb.menu.settings',
      },
    ],
  },
  {
    service: 'kyc',
    title: 'KYC',
    icon: <LeaderboardOutlinedIcon />,
    routes: [
      {
        service: ['kyc'],
        url: '/kyc/persons',
        title: 'common:persons',
      },
      {
        service: ['kyc'],
        url: '/kyc/checks',
        title: 'common:checks',
      },
    ],
  },
  {
    service: 'kycV2',
    title: 'KYC v2',
    icon: <LeaderboardOutlinedIcon />,
    routes: [
      {
        service: ['kycV2'],
        url: '/kycv2/persons',
        title: 'common:persons',
      },
    ],
  },
  {
    service: 'ecommerceRisk',
    title: 'common:ecommerceRisk',
    icon: <StorefrontOutlinedIcon />,
    url: '/ecommerce-risk',
  },
  {
    service: 'kyt',
    title: 'common:transactionMonitoring',
    icon: <ShieldOutlinedIcon />,
    routes: [
      {
        service: ['transactions:email'],
        url: '/transactions',
        title: 'common:transactions',
      },
      {
        service: ['consumerUsers:email', 'businessUsers:email'],
        url: '/kyt/users',
        title: 'common:clients',
      },
      {
        service: ['externalPaymentMethods:email'],
        url: '/external-payment-methods',
        title: 'common:externalPaymentMethods',
      },
      {
        service: ['retrieveClientInstanceRules', 'retrieveClientRules', 'sendSlackMessage'],
        url: '/rules',
        title: 'common:rules',
      },
    ],
  },
  {
    service: 'onboarding',
    title: 'common:onboarding',
    icon: <LibraryBooksIcon />,
    url: '/onboardings',
  },
  {
    service: 'aml',
    title: 'common:amlAndList',
    icon: <ManageSearchIcon />,
    routes: [
      {
        service: ['aml'],
        url: '/aml',
        title: 'common:global',
      },
      {
        service: ['amlBR'],
        url: '/br-aml',
        title: 'common:brazil',
      },
    ],
  },
  {
    service: 'amlCrypto',
    title: 'common:amlCrypto',
    icon: <CurrencyBitcoinOutlinedIcon />,
    url: '/aml-crypto',
  },
  {
    service: 'govCheck',
    title: 'common:govcheck',
    icon: <AssuredWorkloadOutlinedIcon />,
    url: '/gov-check',
  },
  {
    service: 'batch',
    title: 'common:batchLoading',
    icon: <MediationOutlined />,
    url: '/batch',
  },
  {
    service: 'kym',
    title: 'KYM',
    icon: <MediationOutlined />,
    routes: [
      {
        service: ['kym'],
        url: '/kym/persons',
        title: 'common:persons',
      },
      {
        service: ['kym'],
        url: '/kym/business',
        title: 'common:business',
      },
    ],
  },
  {
    service: 'admin',
    title: 'common:admin',
    icon: <PersonOutlineOutlinedIcon />,
    routes: [
      {
        service: ['userall'],
        url: '/admin/users',
        title: 'common:dashboardUsers',
      },
      {
        service: ['adminrolesemailClient'],
        url: '/admin/roles',
        title: 'common:roles',
      },
      {
        service: ['lists'],
        url: '/admin/lists/whitelist',
        title: 'common:lists',
      },
      {
        service: [''],
        url: '/admin/opposition-control',
        title: 'common:oppositionControl',
      },
      {
        service: ['usermaster:emailClient'],
        url: '/admin/security',
        title: 'common:securityParameters',
      },
      {
        service: ['allClientConsumptionsBetweenDates'],
        url: '/admin/client-consumptions',
        title: 'common:consumptions',
      },
      {
        service: ['alertSettingsemailClient'],
        url: '/admin/alerts',
        title: 'common:alertSettings',
      },
      {
        service: ['webhooks'],
        url: '/admin/webhooks',
        title: 'common:webhooks',
      },
      {
        service: [''],
        url: '/checklists',
        title: 'common:checklists',
      },
      {
        service: [''],
        url: '/workflows',
        title: 'common:workflows',
        isDemo: true,
      },
      {
        service: ['riskmatrix'],
        url: '/admin/risk-matrix',
        title: 'common:riskMatrix',
      },
      {
        service: ['kyt-import'],
        url: '/admin/kyt-import',
        title: 'messages:kyt-import.menu',
      },
      {
        service: ['totalizers'],
        url: '/admin/totalizadores',
        title: 'Totalizadores',
      },
    ],
  },
  {
    service: 'reportsclienttypes',
    title: 'common:reports',
    icon: <GppMaybeOutlinedIcon />,
    url: '/reports',
  },
  {
    service: 'backoffice',
    title: 'BackOffice',
    icon: <AdminPanelSettingsOutlinedIcon />,
    url: '/backoffice',
  },
]

const verifySideSubBtn = (paths, values) => {
  return values && values.length > 0 ? values?.some((value) => verifySideBtn(paths, value)) : false
}
const verifySideBtn = (paths, value) => {
  return paths && paths.length > 0
    ? paths.some((path) => {
        if (value === 'overview') return !path.includes(value)
        else return path.includes(value)
      })
    : false
}

const useFilteredSidebarConfig = (sidebarConfig, activeServices) => {
  return useMemo(() => {
    return sidebarConfig
      .map((service) => {
        if (verifySideBtn(activeServices, service.service)) {
          const filteredRoutes = service.routes?.filter(
            (subservice) => !subservice.isDemo && verifySideSubBtn(activeServices, subservice.service),
          )

          return {
            ...service,
            routes: filteredRoutes?.length > 0 ? filteredRoutes : undefined,
          }
        }
        return null
      })
      .filter(Boolean)
  }, [sidebarConfig, activeServices])
}

export default useFilteredSidebarConfig
